import { render } from "./HeroiconsOutlineThumbDown.vue?vue&type=template&id=651f6ddd"
const script = {}

import exportComponent from "/home/harlan/sites/kintell-env/api/packages/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineThumbDown.vue"]])

export default __exports__